import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { faBars, faHome } from '../icons/solid.js';
import Icon from './icon.gjs';
import ThemeToggle from './theme-toggle.gjs';
import AccountDropdown from './account-dropdown.gjs';
import NavigationMenuItem from './navigation-menu-item.gjs';

export default class ApplicationPageComponent extends Component {
  @service notify;
  @service theme;
  @service router;

  <template>
    <div class="drawer">
      <input id="my-drawer-3" type="checkbox" class="drawer-toggle" />

      <div class="drawer-content">
        <div class="fixed bottom-0 left-0 right-0 top-0 flex flex-col">

          <div
            class="flex w-full items-center p-1 bg-neutral text-neutral-content"
          >
            <div class="w-full navbar-start space-x-1">
              <label for="my-drawer-3" class="btn btn-square btn-ghost">
                <Icon @icon={{faBars}} />
              </label>

              <LinkTo
                @route="index"
                class="btn btn-ghost no-animation text-base normal-case"
              >
                {{yield to="header"}}
              </LinkTo>

              <div class="hidden lg:block">
                {{yield to="menu"}}
              </div>
            </div>

            <div class="navbar-end space-x-2">
              <ThemeToggle />
              <AccountDropdown />
            </div>
          </div>

          <div class="relative flex flex-1 flex-row overflow-hidden">
            <ul class="menu bg-base-200 px-0 py-2 space-y-3">
              <NavigationMenuItem
                @icon={{faHome}}
                @iconOnly={{true}}
                @title={{t "home.title"}}
                @route="index"
              />
              {{yield (component NavigationMenuItem iconOnly=true) to="menu"}}
            </ul>

            <div class="relative flex flex-1 flex-col overflow-hidden">
              <div class="relative flex flex-1 flex-col overflow-hidden p-3">
                {{yield to="content"}}

                {{#if this.notify.workingOnIt}}
                  <div
                    class="absolute top-0 right-0 bottom-0 left-0 flex flex-1 items-center justify-center
                      {{if this.theme.isDark 'bg-black/75' 'bg-white/75'}}"
                  >
                    <span
                      class="loading loading-bars loading-sm w-12 h-12 text-primary"
                    />
                  </div>
                {{/if}}
              </div>

              <div class="toast">
                {{#each this.notify.alerts as |alert|}}
                  <button
                    type="button"
                    class="alert {{if alert.error 'alert-error' 'alert-info'}}"
                    {{on "click" (fn this.notify.clearAlert alert)}}
                  >
                    <span>{{alert.message}}</span>
                  </button>
                {{/each}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="drawer-side">
        <label for="my-drawer-3" class="drawer-overlay"></label>
        <ul class="menu menu-lg h-full w-80 bg-base-200 p-4 space-y-2">
          <NavigationMenuItem
            @icon={{faHome}}
            @title={{t "home.title"}}
            @route="index"
          />
          {{yield NavigationMenuItem to="menu"}}
        </ul>
      </div>

    </div>
  </template>
}
